import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class KnowledgeDocumentTitle extends PrimitiveValueObject<string> {
  static create(value: string): KnowledgeDocumentTitle {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new KnowledgeDocumentTitle(value);
  }
}
